export var SocialShareTypes;

(function (SocialShareTypes) {
  SocialShareTypes["EMAIL"] = "email";
  SocialShareTypes["FACEBOOK"] = "facebook";
  SocialShareTypes["LINE"] = "line";
  SocialShareTypes["LINKEDIN"] = "linkedIn";
  SocialShareTypes["MIXI"] = "mixi";
  SocialShareTypes["PRINT"] = "print";
  SocialShareTypes["TWITTER"] = "twitter";
  SocialShareTypes["WEIBO"] = "weibo";
  SocialShareTypes["WHATSAPP"] = "whatsApp";
})(SocialShareTypes || (SocialShareTypes = {}));